import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { Link, LinkProps } from "react-router-dom";
import styles from "./style.module.scss";
import { Tooltip } from "react-tippy";
import cx from "classnames";

type CircleButtonProps = {
  iconProps: FontAwesomeIconProps
  tooltip: string
} & LinkProps & React.RefAttributes<HTMLAnchorElement>;

/** Convierte el tooltip en un identificador estable para pruebas E2E. */
const slugify = (text: string): string =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

const CircleButton = (props: CircleButtonProps) => {
  const { children, onClick, tooltip, iconProps: customIconProps, ...rest } = props;
  const { className, ...iconProps } = customIconProps

  const linkOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      onClick(e);
    }
  }

  return (
    <>
      <Tooltip
        title={tooltip}
        trigger="mouseenter"
      >
        <Link
          data-testid={`action-${slugify(tooltip)}`}
          {...rest}
          onClick={linkOnClick}
        >
          <FontAwesomeIcon className={cx([styles.icon, className])} {...iconProps} />
        </Link>
      </Tooltip>
    </>
  )
}

export default CircleButton;